export const PeopleGroup = {
  flow: 'y',
  gap: 'Z',
  marginBottom: 'Z1',

  CaptionTitle: {
    fontSize: 'Y2',
    Text: {
      text: (el) => el.parent?.parent?.label || ''
    }
  },

  List: {
    flow: 'y',
    gap: 'Y',
    childExtends: 'AppPersonRow',
    childrenAs: 'state',
    children: (el, s) => {
      const group = el.parent.groupName
      if (group === 'team') return el.call('activeMembers')
      return el.call('peopleByShareClass', group)
    }
  }
}

export const AppPersonRow = {
  flow: 'x',
  align: 'center left',
  gap: 'Z',
  padding: 'Z Z1',
  margin: '- -Z1',
  round: 'Z',
  fontSize: 'Z1',
  cursor: 'pointer',
  attr: {
    'data-personrow': 'true',
    'data-email': (el, s) => (s && s.email) || ''
  },
  ':hover': { background: 'overlay' },
  onClick: (e, el, s) => {
    e.stopPropagation()
    const rect = el.node.getBoundingClientRect()
    const CARD_W = 320
    const CARD_H = 280
    const M = 8
    const vw = window.innerWidth
    const vh = window.innerHeight
    let x = rect.right + M
    let y = rect.top
    if (x + CARD_W > vw) x = Math.max(M, rect.left - CARD_W - M)
    if (y + CARD_H > vh) y = Math.max(M, vh - CARD_H - M)
    s.root.update({
      selectedPerson: {
        name: s.name,
        email: s.email,
        avatar: s.avatar,
        location: s.location,
        timezone: s.timezone,
        x,
        y
      }
    })
  },

  Avatar: {
    avatarType: 'initials',
    boxSize: 'B1 B1',
    src: (el, s) => el.call('avatarUrl', s && s.name)
  },

  Info: {
    flow: 'y',
    gap: 'V',
    flex: '1',
    minWidth: '0',
    overflow: 'hidden',

    Name: {
      tag: 'span',
      fontSize: 'Z2',
      color: 'title',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      text: (el, s) => s.name || ''
    },
    Caption: {
      tag: 'span',
      fontSize: 'Y2',
      color: 'caption',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      text: (el, s) => s.position || ''
    }
  }
}
